import { render, staticRenderFns } from "./PropertyEditor.vue?vue&type=template&id=62304f16&scoped=true&"
import script from "./PropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./PropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62304f16",
  null
  
)

export default component.exports